/** Multiplayer accusation phase state (2–3 players). */
/** All players picked the same suspect (and everyone has a pick). */
export function allPicksMatch(phase, playerIds) {
    let pick;
    for (const id of playerIds) {
        const p = phase.picks[id] ?? null;
        if (!p)
            return false;
        if (pick === undefined)
            pick = p;
        else if (pick !== p)
            return false;
    }
    return (pick ?? null) !== null;
}
